import {
  LOAN_APPLICATION_FETCH_START,
  LOAN_APPLICATION_FETCH_SUCCESS,
  LOAN_APPLICATION_FETCH_FAILURE,
  LOAN_APPLICATION_UPDATE_START,
  LOAN_APPLICATION_UPDATE_SUCCESS,
  LOAN_APPLICATION_UPDATE_FAILURE,
} from './types';

//
// FETCH ACTIONS
//
export const loanApplicationFetchStart = (payload) => ({
  type: LOAN_APPLICATION_FETCH_START,
  payload: payload
})

export const loanApplicationFetchSuccess = (payload) => ({
  type: LOAN_APPLICATION_FETCH_SUCCESS,
  payload: payload
})

export const loanApplicationFetchFailed = (payload) => ({
  type: LOAN_APPLICATION_FETCH_FAILURE,
  payload: payload
})

//
// UPDATE ACTIONS
//
export const loanApplicationUpdateStart = (payload) => ({
  type: LOAN_APPLICATION_UPDATE_START,
  payload: payload
})

export const loanApplicationUpdateSuccess = (payload) => ({
  type: LOAN_APPLICATION_UPDATE_SUCCESS,
  payload: payload
})

export const loanApplicationUpdateFailed = (payload) => ({
  type: LOAN_APPLICATION_UPDATE_FAILURE,
  payload: payload
})

